/**
 * `hr.ts` — public re-export surface for embeddables consumers (system widgets,
 * renderer, lavender). Most types and helpers now live in
 * `@homerunner-next/widget-core`; this file is a thin convenience layer kept for
 * backwards compat with existing imports.
 */
export type { PluginManifest } from "@homerunner-next/widget-core/manifest";
export type { Feed, Widget } from "@homerunner-next/widget-core/contracts";

export {
  homerunnerApiBaseUrl,
  fetchFeed,
  fetchWidget,
  getFinalSettings,
  extractWidgetId,
  WidgetFetchError,
  isRateLimitError,
  isPermanentError,
  retryTransient,
} from "@homerunner-next/widget-core/runtime";
import {
  STORED_WIDGET_KEYWORDS,
  type StoredWidgetKeyword,
} from "@homerunner-next/widget-registry";

/**
 * Bare keyword enum for the system widget types embeddables ships — derived
 * from the widget registry (#1283), which is the single source of truth.
 * Includes the legacy alias spellings so existing stored configs / embeds
 * keep resolving. NOTE (#1283): iteration order changed from the old
 * hand-grouped listing to the registry's alphabetical order — key SET is
 * unchanged; don't rely on iteration order for grouping.
 */
export const widgets = Object.fromEntries(
  STORED_WIDGET_KEYWORDS.map((keyword) => [keyword, keyword]),
) as { [K in StoredWidgetKeyword]: K };
